module.exports = __webpack_public_path__ + "img/CREATE.919ffb3e.png";